import { useTypewriter } from "../hooks/useTypewriter";
import { shuffle } from "../utilities/mathStuff";


interface CoolTypedThingsProps {
  theme: any
}

function CoolTypedThings(props: CoolTypedThingsProps) {

  const typewriterTexts = [
    "2.2k rated ret paladin",
    "Zezima",
    "building redstone calculators",
    "fire cape owner",
    "Thunderfury Blessed Blade of the Windseeker",
    "selling lobbies 150gp each",
    "LFG SM cath",
    "Stop! You've violated the law!",
    "fighting fearsome mudcrabs",
    "zerging pylons",
    "cleansing Stratholme",
    "praising Talos",
    "performing Sithis's will",
    "abiding by the Nine Divines"
  ];
  const typewriter = useTypewriter(shuffle(typewriterTexts), 200);
  
  return (<>
    Software developer by day,&nbsp;
    <span style={{ color: props.theme.text.contrast1}}>
      {typewriter}
    </span> 
    &nbsp;by night.
  </>);
}

export default CoolTypedThings;
